// extracted by mini-css-extract-plugin
module.exports = {"container":"RateInput_container__k3ZEV","star":"RateInput_star__4KOTg","containerReadOnly":"RateInput_containerReadOnly__3T-dt"};